<div class="flex-container">
  <div class="flex-row flex-justify-center">
    <div class="flex-col-12">
      <div class="grow-slider">
        <app-grow-intro-slider [isLoading]="growIntroLoading$ | async" (finalSubmit)="onSubmit($event)"></app-grow-intro-slider>
      </div>
      <div class="swiss-made">
        <app-swiss-made-footer></app-swiss-made-footer>
      </div>
    </div>
  </div>
</div>
